export const destinations = [
  { id: 'dsm', name: 'Dar es Salaam', country: 'Tanzania' },
];

const interiors = [
  '/img/IMG_3725.jpg',
  '/img/IMG_3726.jpg',
  '/img/IMG_3727.jpg',
  '/img/IMG_3728.jpg',
  '/img/IMG_3729.jpg',
  '/img/IMG_3730.jpg',
  '/img/IMG_3731.jpg',
  '/img/IMG_3737.jpg',
  '/img/IMG_3756.jpg',
  '/img/IMG_3757.jpg',
  '/img/IMG_3780.jpg',
  '/img/IMG_3781.jpg',
  '/img/IMG_3782.jpg',
];

function gallery(i) {
  return [0, 1, 3, 2].map((offset) => interiors[(i + offset) % interiors.length]);
}

function stay(id, name, score, reviews, price, image, amenities, description, popular = false) {
  return {
    id,
    name,
    city: 'Dar es Salaam',
    country: 'Tanzania',
    score,
    reviews,
    price,
    images: gallery(image),
    amenities,
    description,
    ...(popular ? { popular: true } : {}),
  };
}

export const properties = [
  stay('bb1', 'Garden Residences', 9.0, 980, 58, 7, ['Kitchen', 'Free WiFi', 'Air conditioning', 'Lift'], 'Coast stays a short walk from the sand, with air conditioning and lift access. A practical home for sea breeze and family trips.', true),
  stay('bb2', 'Dunes Suites', 9.3, 421, 71, 0, ['Sea view', 'Kitchen', 'Free WiFi', 'Terrace'], 'Light-filled suites near the dunes, with terraces and kitchens. Quiet nights and a steady Indian Ocean breeze.', true),
  stay('bb3', 'Palm Court', 8.8, 256, 53, 1, ['Garden', 'Kitchen', 'Free WiFi', 'Parking'], 'Palm-shaded court apartments with parking and kitchens. A simple base for longer stays on the northern coast.'),
  stay('bb4', 'Ocean Road Stay', 9.1, 338, 66, 8, ['Beach nearby', 'Kitchen', 'Air conditioning', 'Free WiFi'], 'Air-conditioned rooms near the beach road, with kitchens and easy access to seafood spots along the coast.', true),
  stay('bb5', 'Breeze Lofts', 9.4, 187, 79, 10, ['Sea view', 'Kitchen', 'Pool', 'Free WiFi'], 'Upper-floor lofts with a shared pool and sea views. Built for guests who want space after a day on the beach.', true),
  stay('bb6', 'Shore Apartments', 8.9, 214, 54, 3, ['Sea breeze', 'Kitchen', 'Free WiFi', 'Terrace'], 'Quiet shore-side apartments with terraces and kitchens. Close to the northern coastal road and the sand.'),
  stay('bb7', 'Palm Grove', 9.2, 162, 62, 2, ['Garden', 'Kitchen', 'Free WiFi', 'Parking'], 'Garden apartments under palms, with kitchens and parking. A leafy stay a few minutes from the beach.'),
  stay('bb8', 'Tide View', 9.0, 173, 57, 4, ['Sea breeze', 'Kitchen', 'Terrace', 'Free WiFi'], 'Tide-facing rooms with terraces and kitchens. Easy mornings on the sand and evenings on the coast road.'),
  stay('bb9', 'Sea Breeze Stay', 8.7, 141, 49, 5, ['Beach nearby', 'Kitchen', 'Free WiFi', 'Washer'], 'A bright apartment near the water, with a washer and kitchen for longer stays.'),
  stay('bb10', 'Garden Suites', 9.1, 198, 60, 6, ['Garden', 'Kitchen', 'Free WiFi', 'Parking'], 'Garden suites with space to unpack after beach days. Kitchens and parking make family stays easy.'),
  stay('bb11', 'North Coast Stay', 8.8, 226, 55, 9, ['Kitchen', 'Free WiFi', 'Air conditioning', 'Parking'], 'Air-conditioned rooms on the northern stretch, with parking and a kitchen. Shops and the beach road are close.'),
  stay('bb12', 'Sands Apartment', 9.3, 88, 68, 11, ['Beach nearby', 'Kitchen', 'Free WiFi', 'Washer'], 'A calm apartment near the sand, with a washer and kitchen. Built for unhurried weeks by the water.'),
  stay('bb13', 'Courtyard Homes', 8.6, 119, 46, 12, ['Courtyard', 'Kitchen', 'Free WiFi', 'Parking'], 'Shared courtyard homes with parking and kitchens. A quiet street just inland from the beach.'),
  stay('bb14', 'Horizon Lofts', 9.2, 154, 74, 0, ['Sunset view', 'Kitchen', 'Pool', 'Free WiFi'], 'West-facing lofts with a shared pool. Evenings look out toward the coast after a swim.'),
  stay('bb15', 'Reef Road Residences', 9.0, 268, 63, 4, ['Beach access', 'Kitchen', 'Pool', 'Free WiFi'], 'Beach-road residences with a pool and kitchen. A short walk to the sand and seafood grills.'),
  stay('bb16', 'Family Stay', 8.9, 204, 51, 7, ['Kitchen', 'Washer', 'Free WiFi', 'Parking'], 'Family-sized rooms with a washer, kitchen and parking. Close to local shops and the road down to the water.'),
];

export function scoreLabel(score) {
  if (score >= 9.5) return 'Exceptional';
  if (score >= 9) return 'Superb';
  if (score >= 8.5) return 'Fabulous';
  if (score >= 8) return 'Very good';
  if (score >= 7) return 'Good';
  return 'Review score';
}

export function formatCount(n) {
  return n.toLocaleString('en-GB');
}

export const villa = {
  name: 'Kaya Serene Villa',
  address: 'Dar es Salaam, Tanzania',
  checkIn: '14:00',
  checkOut: '11:00',
};

export const countries = [
  'Tanzania',
  'Kenya',
  'Uganda',
  'South Africa',
  'United Kingdom',
  'United States',
  'Other',
];

export const arrivalTimes = [
  '14:00',
  '15:00',
  '16:00',
  '17:00',
  '18:00',
  '19:00',
  '20:00',
  '21:00',
  'Flexible',
];

export function roomMeta(property) {
  return property.score >= 9.2
    ? { sleeps: 4, beds: '1 king bed' }
    : { sleeps: 2, beds: '1 queen bed' };
}

export function stayQuote(room, nights) {
  const total = room.price * nights;
  return { total, nightly: room.price };
}
